import { create } from 'zustand';
import { Tokens } from '@tassomutuo-backoffice/types';
import { User } from '@tassomutuo-backoffice/types';

export interface UserState {
  isAuthenticated: boolean;
  user: User | null;
  setUser: (user: User) => void;
  resetUser: () => void;
  setIsAuthenticated: (isAuthenticated: boolean) => void;
  setTokens: (tokens: Tokens) => void;
  tokens: Tokens | null;
}

export const useUserStore = create<UserState>((set) => ({
  isAuthenticated: false,
  user: null,
  tokens: null,
  setTokens: (tokens) => {
    // LocalStorage.tokens.set(tokens);
    set(() => ({ tokens }));
  },
  setUser: (user) => set(() => ({ user })),
  resetUser: () => set(() => ({ user: null })),
  setIsAuthenticated: (isAuthenticated: boolean) =>
    set(() => ({ isAuthenticated })),
}));
